import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import AmpButton from "../common/AmpButton/AmpButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";

import "./Toc.css"
import { RootState } from "../../redux/reducers/root";
import { useSelector } from "react-redux";
import { TokenState } from "../../redux/reducers/getAuthReducer/tokenReducer";
import addSuperScript from "../../utils/superscript";

interface TocProps {
    showTitle?: boolean | undefined;
    showPrintButton?: boolean | undefined;
}

export default function Toc(props: TocProps): JSX.Element{

    const tokenStore = useSelector((state: RootState) => state.authReducer.token as TokenState);

    const { t } = useTranslation("toc");

    const { showTitle, showPrintButton } = props;

    const contentRef = useRef(null);

    const renderTocParagraph = () => {
        const arr = [];
        for (let i = 1; i <= 15; i++) {
            arr.push(<p>{addSuperScript(t("paragraph-" + i) as string)}</p>);
        }
        return arr;
    }

    const printToc = () => {
        if (contentRef.current) {
            const contents = (contentRef.current as HTMLSpanElement).innerHTML;
            const frame = document.createElement('iframe');
            frame.name = "frame";
            frame.style.position = "absolute";
            frame.style.top = "-1000000px";
            document.body.appendChild(frame);
            const frameDoc = frame.contentWindow ? frame.contentWindow.document : frame.contentDocument;
            if (frameDoc) {
                frameDoc.open();
                frameDoc.write('<html><head><title>' + t("title") as string +'</title>');
                frameDoc.write('</head><body>');
                frameDoc.write(contents);
                frameDoc.write('</body></html>');
                frameDoc.close();
                setTimeout(function () {
                    frame.focus();
                    if (frame.contentWindow) {
                        frame.contentWindow.print();
                    }
                    document.body.removeChild(frame);
                }, 500);
            }            
        }       
        return false;
    }
    const contactUsLink = tokenStore.tokenSet ? "#/amp/contact-us" : "#/auth/contact-us"
    return (
        <div className="toc-container">  
            <span className="toc-content" ref={contentRef}>
                {showTitle && <h2 data-testid="title-toc">{addSuperScript(t("title") as string)}</h2>}
                {renderTocParagraph()}
                <p>{t("paragraph-16-1") as string} <a href={contactUsLink} target="_blank" rel="noreferrer noopener">{t("hyperlink-1-text") as string}</a> {t("paragraph-16-2") as string} <a href={t("hyperlink-2") as string} target="_blank" rel="noreferrer noopener">{t("hyperlink-2-text") as string}</a>.</p>
            </span>
            {showPrintButton && <div className="toc-footer">
                <div className="toc-questions">
                    <p><b>{t("question-1") as string}</b><br></br><a href={contactUsLink} target="_blank" rel="noreferrer noopener">{t("question-hyperlink-text") as string}</a> {t("question-2") as string}</p>
                </div>
                <div className="toc-print">
                    <AmpButton type="submit" text={<p><FontAwesomeIcon icon={faPrint} /> {t("print") as string}</p>} onClick={() => printToc()} />
                </div>
            </div>}
        </div>
    )
}